import { render, staticRenderFns } from "./fredialog.vue?vue&type=template&id=3b3096d4&scoped=true"
import script from "./fredialog.vue?vue&type=script&lang=js"
export * from "./fredialog.vue?vue&type=script&lang=js"
import style0 from "./fredialog.vue?vue&type=style&index=0&id=3b3096d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3096d4",
  null
  
)

export default component.exports